exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-data__title{font-size:20px;font-weight:600;letter-spacing:2.1px;text-transform:uppercase}.clinic-data__logo{margin:4px auto 44px}.page-title{font-size:32px;color:var(--theme-text-color);letter-spacing:.5px;line-height:1.31;font-weight:500;margin-bottom:27px}", ""]);

// exports
